import { RecentQuotes } from '@app-model/api';
import { Role } from '@app-model/enums';
import { Markup, UserResponse } from '@app-model/login';
import { AvailableRole, CurrentUsers } from '@app-model/response';

import * as UserActions from './user.actions';

export const featureKey = 'userState';
export interface State {
  appVersion: string;
  emulatedDealer: boolean;
  error: string;
  isLoggedIn: boolean;
  markup: Markup;
  originalUser: UserResponse;
  pendingContracts: number;
  previousUser: string;
  recentQuotes: RecentQuotes[];
  sessionExpired: boolean;
  success: boolean;
  user: UserResponse;
  // Dealer Admin
  readonlyView: boolean;
  roles: AvailableRole[];
  users: CurrentUsers[];
}

const InitialState: State = {
  appVersion: '',
  emulatedDealer: false,
  error: '',
  isLoggedIn: false,
  markup: new Markup(),
  originalUser: undefined,
  pendingContracts: 0,
  previousUser: '',
  readonlyView: false,
  recentQuotes: [],
  roles: [],
  sessionExpired: false,
  success: false,
  user: undefined,
  users: [],
};

export function reducer(state: State = InitialState, action: UserActions.All): State {
  switch (action.type) {
    case UserActions.LOGIN_SUCCESS: {
      return {
        ...state,
        isLoggedIn: true,
        markup: action.payload.response.userDefaults.markup,
        originalUser: action.payload.response,
        readonlyView: isReadonlyView(action.payload.response.roles),
        success: true,
        user: action.payload.response,
      };
    }

    case UserActions.EMULATE_DEALER: {
      const user = JSON.parse(JSON.stringify(state.originalUser));

      return {
        ...state,
        originalUser: user,
        user: action.payload,
        emulatedDealer: true,
        readonlyView: isReadonlyView(action.payload.roles),
      };
    }

    case UserActions.RESET_DEALER: {
      return {
        ...state,
        user: state.originalUser,
        readonlyView: isReadonlyView(state.originalUser.roles),
        emulatedDealer: false,
      };
    }

    case UserActions.LOGIN_FAILURE: {
      return { ...state, success: false, error: action.payload };
    }

    case UserActions.SAVE_MARKUP: {
      return { ...state, markup: action.payload };
    }

    case UserActions.UPDATE_PENDING_NUMBER: {
      return { ...state, pendingContracts: action.payload };
    }

    case UserActions.GET_RECENT_QUOTES_SUCCESS: {
      return { ...state, recentQuotes: action.payload };
    }

    case UserActions.DELETE_QUOTE_SUCCESS: {
      return { ...state, recentQuotes: action.payload };
    }

    case UserActions.UPDATE_PREVIOUS_USER: {
      return { ...state, previousUser: action.payload };
    }

    case UserActions.UPDATE_VERSION: {
      return { ...state, appVersion: action.payload };
    }

    case UserActions.GETUSERS_SUCCESS: {
      return { ...state, users: action.payload.currentUsers, roles: action.payload.availableRoles };
    }

    case UserActions.LOGOUT_SUCCESS: {
      return {
        ...state,
        user: undefined,
        originalUser: undefined,
        emulatedDealer: false,
        recentQuotes: [],
        isLoggedIn: false,
        error: '',
        success: false,
        sessionExpired: false,
        markup: new Markup(),
        readonlyView: false,
      };
    }

    default: {
      return state;
    }
  }
}

const isReadonlyView = (roles: Role[]): boolean =>
  roles.includes(Role.CorporateSales) || roles.includes(Role.RORegister);
